import {
  applyMiddleware,
  compose,
  createStore,
  StoreEnhancer,
  StoreCreator,
} from 'redux';
import { History } from 'history';
import thunk, { Store } from 'redux-thunk';
import rootReducer, { AppState } from './reducers';
import trackingMiddleware from '../middlewares/tracking-middleware';
import hydrationMiddleware from '../middlewares/hydration-middleware';
import routerMiddleware from '../middlewares/router-middleware';
import { getWindow } from '../modules/helpers';

async function defaultCallAsync(fn: Function, ...args: {}[]): Promise<{}> {
  return await fn(...args);
}

export default function configureStore(
  initialState: AppState = {} as AppState,
  history: History
): Store<AppState> {
  const thunkMiddleware = thunk.withExtraArgument(defaultCallAsync);

  const middlewaresEnhancer: StoreEnhancer<AppState> = applyMiddleware(
    thunkMiddleware,
    hydrationMiddleware,
    routerMiddleware(history),
    trackingMiddleware
  );
  const window = getWindow();
  const devToolsExtension = window && window.devToolsExtension;
  const devToolsEnhancer = devToolsExtension
    ? devToolsExtension()
    : (f: StoreCreator) => f;
  const enhancer = compose(middlewaresEnhancer, devToolsEnhancer);
  const store = createStore(rootReducer, initialState, enhancer);

  return store;
}
